<template>
  <footer class="max-w-2xl mx-auto px-5 md:px-10 py-8 text-theme-text-tertiary flex flex-col lg:flex-row flex-wrap justify-between items-center">
    <div class="mb-4 lg:mb-0">
      <span class="block md:inline-block mb-4 md:mb-0 text-center">&copy; ARK.io | {{ year }}. {{ $t("All rights reserved") }}</span> <div class="block md:inline-block"><span class="hidden md:inline-block"> | </span> <span>{{ $t("Version") }}: <a :href="versionLink" target="_blank">{{ version }}</a> | {{ $t("Date") }}: {{ date }}</span></div>
    </div>
    <div class="text-center">
      <a href="https://www.facebook.com/arkecosystem" target="_blank">
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px"
          class="m-2">
          <path fill-rule="evenodd"  fill="currentColor" d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"/>
        </svg>
      </a>

      <a href="https://twitter.com/ArkEcosystem" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/>
        </svg>
      </a>

      <a href="https://www.youtube.com/channel/UCpc2k6zOOutGT9y56urDClg" target="_blank">
        <svg
        viewBox="0 0 24 24"
        class="m-2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
        </svg>
      </a>

      <a href="mailto:info@ark.io" target="_blank">
        <svg
          viewBox="0 0 14 14"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M0.247,5.753 L3.472,6.939 L4.722,10.892 C4.801,11.145 5.116,11.239 5.324,11.071 L7.123,9.628 C7.311,9.476 7.580,9.469 7.777,9.610 L11.020,11.928 C11.243,12.088 11.560,11.967 11.615,11.701 L13.991,0.450 C14.052,0.160 13.763,-0.082 13.482,0.025 L0.243,5.053 C-0.084,5.177 -0.081,5.632 0.247,5.753 ZM4.520,6.308 L10.825,2.485 C10.938,2.416 11.054,2.567 10.957,2.656 L5.754,7.418 C5.571,7.585 5.453,7.809 5.420,8.053 L5.242,9.346 C5.219,9.519 4.973,9.536 4.925,9.369 L4.243,7.011 C4.164,6.742 4.279,6.455 4.520,6.308 Z"/>
        </svg>
      </a>

      <a href="https://www.reddit.com/r/arkecosystem" target="_blank">
        <svg
          viewBox="0 0 17 17"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M17.000,7.592 C17.000,6.426 16.045,5.476 14.873,5.476 C14.218,5.476 13.617,5.767 13.214,6.266 C12.089,5.757 10.804,5.443 9.446,5.343 L10.613,1.674 L13.220,2.236 C13.419,3.008 14.125,3.582 14.964,3.582 C15.956,3.582 16.764,2.778 16.764,1.790 C16.764,0.803 15.956,-0.001 14.964,-0.001 C14.247,-0.001 13.626,0.419 13.337,1.024 L10.330,0.376 C10.023,0.310 9.716,0.486 9.621,0.784 L8.181,5.312 C6.591,5.351 5.082,5.678 3.784,6.266 C3.383,5.767 2.780,5.476 2.126,5.476 C0.953,5.476 -0.000,6.426 -0.000,7.592 C-0.000,8.159 0.223,8.691 0.621,9.086 C0.384,9.592 0.263,10.118 0.263,10.654 C0.263,12.108 1.138,13.465 2.727,14.475 C4.273,15.458 6.323,15.999 8.499,15.999 C10.676,15.999 12.725,15.458 14.272,14.475 C15.860,13.465 16.735,12.108 16.735,10.654 C16.735,10.118 16.615,9.592 16.378,9.086 C16.775,8.691 17.000,8.159 17.000,7.592 ZM0.933,8.317 C0.799,8.101 0.729,7.853 0.729,7.592 C0.729,6.826 1.355,6.202 2.126,6.202 C2.457,6.202 2.768,6.314 3.016,6.520 C2.128,7.022 1.428,7.625 0.933,8.317 ZM4.134,9.543 C4.134,8.710 4.815,8.032 5.653,8.032 C6.491,8.032 7.173,8.710 7.173,9.543 C7.173,10.376 6.491,11.054 5.653,11.054 C4.815,11.054 4.134,10.376 4.134,9.543 ZM11.616,12.992 C11.024,13.635 9.830,14.034 8.499,14.034 C7.169,14.034 5.975,13.635 5.383,12.992 C5.273,12.873 5.217,12.718 5.224,12.557 C5.231,12.396 5.301,12.247 5.420,12.138 C5.533,12.035 5.678,11.979 5.831,11.979 C6.001,11.979 6.164,12.050 6.279,12.175 C6.631,12.558 7.544,12.825 8.499,12.825 C9.454,12.825 10.367,12.558 10.720,12.175 C10.834,12.050 10.998,11.979 11.168,11.979 C11.321,11.979 11.466,12.035 11.578,12.138 C11.698,12.247 11.768,12.396 11.775,12.557 C11.782,12.718 11.725,12.873 11.616,12.992 ZM11.346,11.054 C10.508,11.054 9.826,10.376 9.826,9.543 C9.826,8.710 10.508,8.032 11.346,8.032 C12.183,8.032 12.865,8.710 12.865,9.543 C12.865,10.376 12.183,11.054 11.346,11.054 ZM16.065,8.317 C15.570,7.625 14.871,7.022 13.982,6.520 C14.231,6.314 14.542,6.202 14.873,6.202 C15.643,6.202 16.270,6.826 16.270,7.592 C16.270,7.853 16.200,8.101 16.065,8.317 Z"/>
        </svg>
      </a>

      <a href="https://github.com/ArkEcosystem" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
        </svg>
      </a>

      <a href="https://bitcointalk.org/index.php?topic=1649695.0" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M23.638 14.904c-1.602 6.43-8.113 10.34-14.542 8.736C2.67 22.05-1.244 15.525.362 9.105 1.962 2.67 8.475-1.243 14.9.358c6.43 1.605 10.342 8.115 8.738 14.548v-.002zm-6.35-4.613c.24-1.59-.974-2.45-2.64-3.03l.54-2.153-1.315-.33-.525 2.107c-.345-.087-.705-.167-1.064-.25l.526-2.127-1.32-.33-.54 2.165c-.285-.067-.565-.132-.84-.2l-1.815-.45-.35 1.407s.975.225.955.236c.535.136.63.486.615.766l-1.477 5.92c-.075.166-.24.406-.614.314.015.02-.96-.24-.96-.24l-.66 1.51 1.71.426.93.242-.54 2.19 1.32.327.54-2.17c.36.1.705.19 1.05.273l-.51 2.154 1.32.33.545-2.19c2.24.427 3.93.257 4.64-1.774.57-1.637-.03-2.58-1.217-3.196.854-.193 1.5-.76 1.68-1.93h.01zm-3.01 4.22c-.404 1.64-3.157.75-4.05.53l.72-2.9c.896.23 3.757.67 3.33 2.37zm.41-4.24c-.37 1.49-2.662.735-3.405.55l.654-2.64c.744.18 3.137.524 2.75 2.084v.006z"/>
        </svg>
      </a>

      <a href="https://ark.io/slack" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd"  fill="currentColor" d="M9.879 10.995l1.035 3.085 3.205-1.074-1.035-3.074-3.205 1.08v-.017z"/><path fill-rule="evenodd"  fill="currentColor" d="M18.824 14.055l-1.555.521.54 1.61c.218.65-.135 1.355-.786 1.574-.15.045-.285.067-.435.063-.511-.015-.976-.338-1.155-.849l-.54-1.607-3.21 1.073.539 1.608c.211.652-.135 1.358-.794 1.575-.15.048-.285.067-.435.064-.51-.015-.976-.34-1.156-.85l-.539-1.619-1.561.524c-.15.045-.285.061-.435.061-.511-.016-.976-.345-1.155-.855-.225-.66.135-1.364.78-1.575l1.56-.525L7.5 11.76l-1.551.525c-.141.048-.285.066-.428.064-.495-.016-.975-.338-1.141-.848-.209-.65.135-1.354.796-1.574l1.56-.52-.54-1.605c-.21-.654.136-1.359.796-1.575.659-.22 1.363.136 1.574.783l.539 1.608L12.3 7.544l-.54-1.605c-.209-.645.135-1.35.789-1.574.652-.211 1.359.135 1.575.791l.54 1.621 1.555-.51c.651-.219 1.356.135 1.575.779.218.654-.135 1.359-.784 1.575l-1.557.524 1.035 3.086 1.551-.516c.652-.211 1.358.135 1.575.795.22.66-.135 1.365-.779 1.574l-.011-.029zm4.171-5.356C20.52.456 16.946-1.471 8.699 1.005.456 3.479-1.471 7.051 1.005 15.301c2.475 8.245 6.046 10.17 14.296 7.694 8.245-2.475 10.17-6.046 7.694-14.296z"/>
        </svg>
      </a>

      <a href="https://gitter.im/ark-developers/Lobby" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd" fill="currentColor" d="M8.501 4.001H10.5V24H8.501V4.001zm6.999 0V24h-2V4.001h2zM3.5 0h2.001v15H3.5V0zm15 4.001h2V15h-2V4.001z" />
        </svg>
      </a>

      <a href="https://steemit.com/@arkecosystem" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd" fill="currentColor" d="M3.927 2.596c.264.045-.397 1.778-.028 3.76.318 1.697 4.313 8.275 4.148 10.529-.128 1.418-3.408 4.74-3.753 4.52-.377-.105.996-2.361.486-4.244C4.19 14.97.673 9.301.677 6.798c0-1.832 3.011-4.32 3.25-4.202zM11.44.005c.336.058-.506 2.271-.034 4.791.405 2.17 5.501 10.555 5.292 13.432-.166 1.809-4.348 6.043-4.789 5.76-.479-.131 1.271-3.008.622-5.406-.755-2.796-5.238-10.026-5.235-13.218 0-2.338 3.842-5.509 4.144-5.359zm7.754 2.591c.27.045-.393 1.778-.023 3.761.318 1.697 4.313 8.275 4.148 10.529-.125 1.418-3.408 4.74-3.754 4.52-.377-.105.996-2.361.488-4.244-.594-2.192-4.11-7.861-4.105-10.363 0-1.832 3.014-4.32 3.248-4.202h-.002z" />
        </svg>
      </a>

      <a href="https://blog.ark.io" target="_blank">
        <svg
          viewBox="0 0 24 24"
          class="m-2"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="16px" height="16px">
          <path fill-rule="evenodd" fill="currentColor" d="M2.846 6.36c.03-.295-.083-.586-.303-.784l-2.24-2.7v-.403H7.26l5.378 11.795 4.728-11.795H24v.403l-1.917 1.837c-.165.126-.247.333-.213.538v13.5c-.034.204.048.41.213.537l1.87 1.837v.403h-9.41v-.403l1.937-1.882c.19-.19.19-.246.19-.538V7.794l-5.39 13.688h-.727L4.278 7.794v9.174c-.052.386.076.774.347 1.053l2.52 3.06v.402H0v-.403l2.52-3.06c.27-.278.39-.67.326-1.052V6.36z" />
        </svg>
      </a>

    </div>
  </footer>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'

export default {
  computed: {
    year() {
      return moment().format('Y')
    },
    version() {
      return GIT_VERSION
    },
    versionLink() {
      return `https://github.com/ArkEcosystem/ark-explorer/commit/${GIT_VERSION}`
    },
    date() {
      return GIT_DATE
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue